var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 720,
    height: 642,
    viewBox: "0 0 720 642",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M537.969 129.872C418.537 -8.4491 215.443 -61.462 45.6001 97.7676C-54.3475 191.47 36.2937 309.27 69.6417 385.668C102.99 462.066 97.4645 544.029 236.286 605.952C375.107 667.875 621.727 663.05 696.179 486.932C770.63 310.814 657.402 268.192 537.969 129.872Z",
    fill: "#FF7131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookShape);
export default __webpack_public_path__ + "static/media/book-shape.bec8157f.svg";
export { ForwardRef as ReactComponent };